import Constants from 'common/constants'

const LOGIN_ROUTE = '/login'

export function clearRedirectRoute() {
  sessionStorage.removeItem(Constants.REDIRECT_TO_LOCAL_STORAGE)
}

export function setRedirectRoute() {
  if (window.location.pathname !== LOGIN_ROUTE) {
    sessionStorage.setItem(
      Constants.REDIRECT_TO_LOCAL_STORAGE,
      window.location.pathname
    )
  }
}

export function getRedirectRoute(isAuthenticated: boolean) {
  const redirectRoute = sessionStorage.getItem(
    Constants.REDIRECT_TO_LOCAL_STORAGE
  )

  // Se não há rota de redirecionamento salva, usa a rota padrão
  if (!redirectRoute || redirectRoute === LOGIN_ROUTE) {
    return isAuthenticated ? '/admin' : '/'
  }

  return redirectRoute
}
